const lang = {
  contact: 'יצירת קשר',
  experience: 'ניסיון',
  education: 'השכלה',
  skills: 'כישורים',
  about: 'תמצית'
};
export default lang;



// WEBPACK FOOTER //
// ./src/lang/he.js